export default "__VITE_ASSET__c7cb96f6__"